import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";
import { Search, Coins, Store } from "lucide-react";
import { rarityIndex } from "@/components/ItemModal";

export default function NetCrawler() {
  const { refreshUser } = useOutletContext();
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);

  const search = async (e) => {
    e?.preventDefault(); setBusy(true);
    try { const { data } = await api.get(`/shops/search?q=${encodeURIComponent(q)}`); setRows(data.results); }
    catch { toast.error("Search failed"); } finally { setBusy(false); }
  };
  const buy = async (r) => {
    try { await api.post(`/stalls/${r.listing_id}/buy`); toast.success(`Bought ${r.item.name} for ${r.price} Bits!`); refreshUser?.(); search(); }
    catch (e) { toast.error(e.response?.data?.detail || "Purchase failed"); }
  };

  return (
    <div data-testid="netcrawler-page" className="max-w-3xl mx-auto">
      <span className="label-cap text-primary flex items-center gap-2"><Search className="w-4 h-4" /> The Net-Crawler</span>
      <h1 className="font-head font-black text-3xl sm:text-4xl mt-2 mb-1">Market Index Scanner</h1>
      <p className="text-muted-foreground mb-5">Search every player shop across the station. Results list the cheapest listings first.</p>

      <form onSubmit={search} className="flex gap-2 mb-6">
        <input data-testid="netcrawler-input" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search item name…" className="input-field flex-1" />
        <button data-testid="netcrawler-search-btn" disabled={busy} className="btn-primary px-6"><Search className="w-4 h-4" /> Scan</button>
      </form>

      {rows && (
        <div className="panel-glow overflow-hidden" data-testid="netcrawler-results">
          {rows.length === 0 ? <p className="text-sm text-muted-foreground p-8 text-center">No listings found. Try another term.</p> : (
            <table className="w-full text-sm">
              <thead><tr className="label-cap text-left border-b border-border"><th className="p-3">Item</th><th className="p-3">Rarity</th><th className="p-3">Seller</th><th className="p-3 text-right">Price</th><th className="p-3"></th></tr></thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.listing_id} className="border-b border-border/50">
                    <td className="p-3 font-semibold">{r.item.name}</td>
                    <td className="p-3 text-muted-foreground text-xs">r{r.item.rarity_index || rarityIndex(r.item.rarity)}</td>
                    <td className="p-3 text-muted-foreground">{r.seller_name}</td>
                    <td className="p-3 text-right mono text-secondary font-bold"><Coins className="w-3.5 h-3.5 inline mr-1" />{r.price}</td>
                    <td className="p-3 text-right">
                      {r.mine ? <span className="label-cap text-[9px]">yours</span> :
                        <button data-testid={`netcrawler-buy-${r.listing_id}`} onClick={() => buy(r)} className="btn-primary text-xs py-1.5 px-3">Buy</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
      {!rows && <p className="text-sm text-muted-foreground text-center py-10 flex flex-col items-center gap-2"><Store className="w-8 h-8 opacity-40" /> Enter a search to scan the market.</p>}
    </div>
  );
}
